import React, { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import { Modal, Form, Input, Row, Col, DatePicker, Divider, Select, message, Button } from "antd";
import { getAllService, getServiceSchedules } from "../../../../actions/Appointment/serviceAction";
import { createAppointment } from "../../../../actions/Appointment/appointmentAction";
import ContactSearchFromInvoice from "./ContactSearchFromInvoice";
import { connect } from "react-redux";

const { RangePicker } = DatePicker;

const AppointmentForm = ({
  visible,
  onCancel,
  onOk,
  fullpageloading,
  getAllService,
  getServiceSchedules,
  createAppointment,
  selectedDate,
}) => {
  const [form] = Form.useForm();
  const fill = useRef({ Contact: null });
  const [services, setServices] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      form.resetFields();
      fetchServices();
      if (selectedDate) {
        form.setFieldsValue({
          date: dayjs(selectedDate, "YYYY-MM-DD", true).isValid() ? dayjs(selectedDate) : null,
        });
      }
    }
  }, [visible, selectedDate, form]);

  const fetchServices = async () => {
    try {
      const serviceData = await getAllService();
      setServices(serviceData.map((service) => ({ label: service.name, value: service.id })));
    } catch (error) {
      console.error("Failed to fetch services:", error);
    }
  };

  const handleServiceChange = async (serviceId) => {
    if (!serviceId) {
      setSchedules([]);
      return;
    }
    try {
      setLoading(true);
      const scheduleData = await getServiceSchedules(serviceId);
      setSchedules(
        scheduleData.map((schedule) => ({
          label: `${schedule.day_of_week} (${schedule.start_time} - ${schedule.end_time})`,
          value: schedule.id,
        }))
      );
    } catch (error) {
      message.error("Failed to fetch schedules for the selected service.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!fill.current.Contact || !fill.current.Contact.id) {
        message.error("Please select a customer before submitting.");
        return;
      }

      const payload = {
        ...values,
        user: fill.current.Contact ? fill.current.Contact.id : null,
        date: values.date ? dayjs(values.date).format("YYYY-MM-DD") : null,
      };

      const response = await createAppointment(payload);

      if (response) {
        message.success("Appointment created successfully!");
        form.resetFields();
        if (onOk) {
          onOk(payload);
        }
      } else {
        message.error("Failed to create appointment. Please try again.");
      }
    } catch (error) {
      console.error("Error during form submission:", error);
      message.error("Failed to create appointment. Please check the form.");
    }
  };

  // Handle cancel explicitly
  const handleCancel = () => {
    console.log("Cancel button clicked"); // Debug log
    form.resetFields(); // Reset form fields when canceling
    if (onCancel) {
      onCancel(); // Call the parent's onCancel to update state
    } else {
      console.error("onCancel prop is not provided or not a function");
    }
  };

  return (
    <Modal
      title="Create Appointment"
      open={visible} 
      onCancel={handleCancel}
      onOk={handleSubmit}
      destroyOnClose={true} 
        // footer={[
        //   <Button 
        //     key="link"
        //     href="/appointment"
        //     type="primary"
        //     loading={loading}
        //     onClick={handleSubmit}
        //   >
        //     Return Back to Appointment
        //   </Button>]}
    >
      <Form form={form} layout="vertical" style={{ marginLeft: "20px" }}>
        <Row gutter={12}>
          <Col span={24}>
            <Col sm={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item name="title" label="Title">
                <Input placeholder="Please enter Title" />
              </Form.Item>
            </Col>
            <Divider style={{ fontSize: "12px" }}>Customer</Divider>
            <Col sm={{ span: 24 }} lg={{ span: 24 }}>
              <ContactSearchFromInvoice
                bill={fill}
                setContact={(contact) => (fill.current.Contact = contact)}
              />
            </Col>
            <Divider style={{ fontSize: "12px" }}>Service</Divider>
            <Form.Item name="service">
              <Select
                options={services}
                placeholder="Please select a service"
                allowClear
                onChange={handleServiceChange}
              />
            </Form.Item>
            <Divider style={{ fontSize: "12px" }}>Schedule</Divider>
            <Form.Item name="schedule" rules={[{ required: true, message: "Please select a schedule" }]}>
              <Select
                options={schedules}
                placeholder="Please select a schedule"
                loading={loading}
                allowClear
              />
            </Form.Item>
            <Form.Item name="date">
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                value={selectedDate ? dayjs(selectedDate, "YYYY-MM-DD") : null}
                onChange={(date, dateString) => {
                  form.setFieldsValue({ date });
                }}
                disabled={true}
              />
            </Form.Item>
            <Form.Item name="description">
              <Input.TextArea placeholder="Please enter additional requests" />
            </Form.Item>
            <Form.Item name="status">
              <Select
                options={[
                  { value: "Pending", label: "Pending" },
                  { value: "Booked", label: "Booked" },
                  { value: "Cancelled", label: "Cancelled" },
                ]}
                placeholder="Select a status option"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(null, {
  getAllService,
  getServiceSchedules,
  createAppointment,
})(AppointmentForm);